module.exports = __webpack_public_path__ + "img/notisphere-blue.8533498a.png";